import { render } from "./AddModalTypeDocument.vue?vue&type=template&id=01110336&ts=true"
import script from "./AddModalTypeDocument.vue?vue&type=script&lang=ts"
export * from "./AddModalTypeDocument.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__